<template>
    <div class="sup-function-module-comp">
        <div class="re-w1200 re-main-col">
            <div class="top-box">
                <span class="top-title">为泛工程领域可视化专业需求量身打造</span>
                <div class="dis-box">
                    <span class="top-dis">测量、剖切、漫游、锚点、标签、标注、二三维联动、小地图、在线编辑等更多功能供您选择</span>
                    <div class="detail-btn-box" @click="func_more_click">
                        <span>查看更多</span>
                        <img src="@/assets/imgs/product/icon_enter.png" />
                    </div>
                </div>
            </div>
            <div class="function-list-box">
                <div class="grid-list-box" ref="ref_func_grid_list_box">
                    <div class="grid-page-box" v-for="(page, pageIndex) in func_page_list_computed" :key="`page_${pageIndex}`">
                        <div
                            class="grid-item-box"
                            v-for="(item, index) in page.gridList"
                            :key="`item_${pageIndex}_${index}`"
                            @click="func_grid_item_click(item)">
                            <re-img
                                class="grid-item-img"
                                :src="downloadBaseUrl_computed(item.coverImgPath)"
                                :ph="require(`@/assets/imgs/product/placeholder_bg.png`)"></re-img>
                            <span>{{ item.coverTitle }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

const props = defineProps({
    function_list: {
        type: Array,
        default: () => [],
    },
});

const ref_func_grid_list_box = ref(null);
const func_grid_perPage = ref(8); // 每页显示的项目数 (2行 * 4列)
const func_show_count = ref(8); // 当前显示数量

const func_page_list_computed = computed(() => {
    const pages = [];
    let pageInde = 0;
    for (let i = 0; i < func_show_count.value; i += func_grid_perPage.value) {
        pages.push({ gridList: props.function_list.slice(i, i + func_grid_perPage.value), pageIndex: pageInde });
        pageInde++;
    }
    return pages;
});

const downloadBaseUrl_computed = computed(() => (path) => {
    let url = '';
    if (path && path.length) {
        url = `${window.downloadBaseUrl}/${path}`;
    }
    return url;
});

// MARK Grid 点击事件
const func_grid_item_click = (item) => {
    router_store.navigateToFuncDetail({ id: item.id });
};

// MARK Click 查看更多
const func_more_click = () => {
    router_store.navigateToFuncList();
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-function-module-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .top-box {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top-title {
            position: relative;
            height: 72px;
            font-weight: 400;
            font-size: 40px;
            color: var(--color-main-text-primary);
        }

        .dis-box {
            position: relative;
            margin-top: 20px;
            width: 100%;
            height: 37px;
            display: flex;
            justify-content: center;
            align-items: center;

            .detail-btn-box {
                position: absolute;
                cursor: pointer;
                right: 16px;
                top: 0;
                width: 123px;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: var(--color-main-product-func-morebtn-bg);
                border-radius: 33px;
                transition: var(--animation-background-color-style);

                span {
                    position: relative;
                    margin-left: 24px;
                    font-weight: 500;
                    font-size: 13px;
                    line-height: 16px;
                    color: var(--color-main-text-brand);
                }

                img {
                    position: relative;
                    margin-right: 24px;
                    width: 13px;
                    height: 13px;
                    transition: var(--animation-margin-style);
                }

                &:hover {
                    background-color: var(--color-main-product-func-morebtn-bg-hover);
                    img {
                        margin-right: 17px;
                    }
                }
            }

            .top-dis {
                position: relative;
                height: 100%;
                font-weight: 400;
                font-size: 20px;
                color: var(--color-main-text-secondary);
                line-height: 37px;
            }
        }
    }

    .function-list-box {
        position: relative;
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;

        .change-btn {
            position: relative;
            width: 68px;
            height: 58px;
            cursor: pointer;
            flex-shrink: 0;
        }

        .grid-list-box {
            display: flex;
            width: 100%;
            margin-top: 56px;
            margin-bottom: 30px;

            .grid-page-box {
                width: 100%;
                flex-shrink: 0;
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                column-gap: 53px;
                row-gap: 40px;
                scroll-snap-align: start;

                .grid-item-box {
                    position: relative;
                    display: flex;
                    width: 260px;
                    height: 236px;
                    align-items: center;
                    justify-content: space-between;
                    border-radius: 10px;
                    cursor: pointer;
                    overflow: hidden;
                    flex-direction: column;
                    padding: 14px;
                    box-sizing: border-box;
                    background-color: var(--color-main-light-bg-white);
                    box-shadow: var(--color-main-card-shadow-big);
                    transition: var(--animation-transform-style);

                    .grid-item-img {
                        position: relative;
                        width: 100%;
                        height: 160px;
                        border-radius: 7px;
                    }

                    span {
                        position: relative;
                        margin-top: 13px;
                        width: 100%;
                        font-weight: 400;
                        font-size: 20px;
                        color: var(--color-main-text-primary);
                    }

                    &:hover {
                        transform: var(--transform-scale-105);
                    }
                }
            }

            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
}
</style>
